import { render } from "./Game404.vue?vue&type=template&id=cfeec6c0"
import script from "./Game404.vue?vue&type=script&lang=js"
export * from "./Game404.vue?vue&type=script&lang=js"

import "./Game404.vue?vue&type=style&index=0&id=cfeec6c0&lang=scss"

import exportComponent from "/builds/chatplace/app-gamification/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__